/**
 * Variáveis do tema claro
 */

const primary = {
  base: '#182e6b',
  lighten3: '#0451a5',
};

const secondary = {
  base: '#7dc344',
};

export default {
  primary,
  secondary,
};
